import React from "react";
import { useDispatch, useSelector } from "react-redux";

import NotAllowedIcon from "@/Components/Icons/NotAllowedIcon";
import { showRoleAccessToast } from "@/utilities/utils";

const NoAccessButtonWrapper = ({
  children,
  rootClass = "",
  iconClass = "",
  _element = "div",
  _checkPermission = [], // ['is_post_job','is_approve_job']
}) => {
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  // console.log("In role access===> clientUserAllPermissions ==>", clientUserAllPermissions, _checkPermission);
  const dispatch = useDispatch();
  let isAllowed = true;
  // Only block when permissions are loaded AND the key is explicitly denied (=== 0)
  if (clientUserAllPermissions && _checkPermission.length > 0) {
    _checkPermission.forEach((ele) => {
      if (clientUserAllPermissions[ele] === 0) {
        isAllowed = false;
      }
    });
  }
  // console.log('isAllowed------> ', isAllowed)
  if (isAllowed) {
    return children;
  }
  return React.createElement(
    _element,
    {
      className: `NotAccessButtonWrapper_Wrapper cursor-pointer group/na opacity-50 hover:opacity-100 ease-linear  relative overflow-hidden ${rootClass}`,
      onClick: () => {
        showRoleAccessToast();
      },
    },
    children,
    React.createElement(
      "div",
      {
        className:
          "bg-notAllowedOverlay absolute left-0 top-0 flex h-full w-full  items-center justify-center opacity-0 transition-opacity group-hover/na:opacity-100",
      },
      React.createElement(NotAllowedIcon, { cls: iconClass }),
    ),
  );
};

export default NoAccessButtonWrapper;
